import { useIntl } from 'dibs-react-intl';
import { Input } from 'dibs-elements/exports/Input.tsx';
import slugify from 'dibs-slugify/exports/slugify.ts';
import formStyles from '../styles/FormGeneral.scss';

export const MatchmakerInput = ({ errorMessage, placeholder, onChange, value, marginRight }) => {
    const intl = useIntl();
    const name = intl.formatMessage(placeholder);
    const inputDataTn = `matchmaker-${slugify(name)}`;
    return (
        <div className={marginRight ? [formStyles.marginRight] : null}>
            <Input
                dataTn={inputDataTn}
                errorMessage={errorMessage}
                placeholder={name}
                name={name}
                defaultValue={value}
                onBlur={onChange}
                hasAnimatedPlaceholder
            />
        </div>
    );
};
